export default function Staff() {
  return (
    <>
      <div className="staff">
        <h1>Tropical Roleplay Staff Team</h1>
        <div className="staffTeam">
          <div>
            <img src="/media/staff/tropicgalxy.png" alt="" />
            <h2>TropicGalxy</h2>
            <p>Owner</p>
          </div>
          <div>
            <img src="/media/staff/millionxsam.png" alt="" />
            <h2>Millionxsam</h2>
            <p>Website creator & Developer</p>
          </div>
          <div>
            <img src="/media/staff/maca.png" alt="" />
            <h2>Maca J.</h2>
            <p>Admin & Developer</p>
          </div>
          <div>
            <img src="/media/staff/echocsitari.png" alt="" />
            <h2>EchoCSitari</h2>
            <p>Admin & Developer</p>
          </div>
          <div>
            <img src="/media/staff/hanklet.png" alt="" />
            <h2>Hanklet69</h2>
            <p>Developer</p>
          </div>
          <div>
            <img src="/media/staff/fire.png" alt="" />
            <h2>Fire1524</h2>
            <p>Admin</p>
          </div>
          <div>
            <img src="/media/staff/ryze.png" alt="" />
            <h2>Ryze</h2>
            <p>Admin</p>
          </div>
        </div>
      </div>
    </>
  );
}
